import { StepperData } from "@/components/molecules/Progress/FlowSteps/FlowSteps";
import { fakeI18n } from "@/i18n";

export enum AddABrokerSteps {
    CHOOSE_BROKER = "choose_broker",
}

export const stepperData: StepperData[] = [
    {
        key: AddABrokerSteps.CHOOSE_BROKER,
        label: fakeI18n.t("Registration.Steps.ChooseBroker"),
    },
];
